export interface Item {
  label: string;
  labelHelper?: string;
  id: string;
  isRenaming: boolean;
  items?: Item[];
  icon?: TreeItemIconType;
}

export enum TreeItemIconType {
  None,
  Database,
  Table,
  FileEarmarkCode,
  Folder,
  File,
  FileSql,
}

export interface ContextMenuItem {
  id: string;
  name: string;
}
